export default __webpack_public_path__ + "static/media/home.a1c3f140.jpg";